// extracted by mini-css-extract-plugin
export default {"bottom":"BottomNav_bottom__QWO0t"};